import React from "react";
import classes from "./Footer.module.css";
const Footer = () => {
  return (
    <div className={classes.footer}>
      &#169; {new Date().getFullYear()}{" "}
      <span class={classes.txt}>Shahriar Saleh</span>. All rights reserved.
    </div>
  );
};

export default Footer;
